import {
    VIRTUAL_DEPART_STORE_SUCCESS,
    VIRTUAL_DEPART_STORE_ERROR,
    RESPONSE_TYPE
} from "../constants/VirtualDepartDriverConstants";
import {NDVSClient} from "../../client/NDVSClient";

export function virtualDepartStoreNetwork(storeId, dispatcher) {
    NDVSClient.virtualDepartStore({
        storeId : storeId
    }).then(({valid, data}) => {
        console.log("virtualDepartStoreNetwork", valid, data, dispatcher);
        if (valid) {
            try {
                dispatcher({
                    type: VIRTUAL_DEPART_STORE_SUCCESS,
                    data: {
                        message: data.responseMessage,
                        alertType: RESPONSE_TYPE[data.responseType]
                    }

                })
            } catch (e) {
                dispatcher({
                    type: VIRTUAL_DEPART_STORE_ERROR,
                    data: {
                        message: data.responseMessage,
                        alertType: RESPONSE_TYPE.ERROR
                    }
                })
            }
        } else {
            dispatcher({
                type: VIRTUAL_DEPART_STORE_ERROR,
                data: {
                    message: data.responseMessage,
                    alertType: RESPONSE_TYPE.ERROR
                }
            })
        }
    });
}


// WEBPACK FOOTER //
// ./src/components/virtualDepartDriver/network/VirtualDepartStoreNetwork.js